<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-left">See dying vegetables life sustain,</p>
<p class="fm-left1">See life dissolving vegetate again;</p>
<p class="fm-left1">All forms that perish other forms supply.</p>
<p class="fm-left1">(By turns we catch the vital breath and die)</p>
<p class="fm-left1">Like bubbles on the sea of matter borne,</p>
<p class="fm-left1">They rise, they break, and to that sea return.</p>
<p class="fm-left2">A<span class="smallcaps">LEXANDER</span> P<span class="smallcaps">OPE</span>: <i>Essay on Man</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?32ddbf2e